import './QualitativeObjectivesTable.css';

import React from 'react';
import B2BTable from '../../../b2b-common/B2BTable';
import { toLocaleDateTime } from '../../../b2b-common/helpers';
import { Add } from '@mui/icons-material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const QualitativeObjectivesTable = ({ areaIndicator, onObjectiveClick, onNewObjective }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const headers = [
        { label: t('Start Date'), align: 'center' },
        { label: t('End Date'), align: 'center' },
        { label: t('Start Value'), align: 'left' },
        { label: t('End Value'), align: 'left' },
        { label: t('Samples'), align: 'center' },
    ];

    const rows = areaIndicator ? areaIndicator.objectiveDTOs.map((objective) =>
    ({
        id: objective.objectiveId,
        cells: [
            { content: toLocaleDateTime(objective.startDate), align: 'center' },
            { content: toLocaleDateTime(objective.endDate), align: 'center' },
            { content: `${objective.startObjectiveValue.qualitativeValue}`, align: 'left' },
            { content: `${objective.endObjectiveValue.qualitativeValue}`, align: 'left' },
            { content: objective.samplesPerObjective.length, align: 'center' },
        ],
    })) : [];

    const handleRowClick = (row) => {
        // console.log('handleRowClick:', row);
        if (onObjectiveClick) {
            onObjectiveClick(areaIndicator.objectiveDTOs.find(objective => objective.objectiveId === row.id));
        }
    };

    return (
        <B2BTable
            headers={headers}
            rows={rows}
            className={'qualitative-objectives'}
            onRowClick={handleRowClick}
            buttons={
                [
                    {
                        label: t('New Objective'),
                        icon: <Add />,
                        onClick: onNewObjective,
                    },
                ]
            }
        />
    );
};

export default QualitativeObjectivesTable;